/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated.js';
import { createObjectNode } from '../../factoriesNumber.js';
export var ObjectNodeDependencies = {
  NodeDependencies,
  createObjectNode
};